import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/types";

// Root selectors
const getGlobalConfigState = (state: RootState) => state.globalConfig;

// GlobalConfig Selectors
export const getGlobalConfigUiSelector = createSelector(
  [getGlobalConfigState],
  (globalConfig) => globalConfig?.globalConfigUi,
);

export const getTimezonesSelector = createSelector(
  [getGlobalConfigState],
  (globalConfig) =>
    (
      globalConfig?.globalConfigUi as unknown as
        | Record<string, unknown>
        | undefined
    )?.timezones,
);
